export default {
    departments: [],
    selectedDepartment: {},
    error: false,
    errorMessage: '',
}
